import { Transaction } from '../Transaction';
import { TransactionTag } from '../TransactionTag';

const unTagTransaction = (transaction: Transaction, tagUUID: TransactionTag['uuid']) => {
	const updatedTags = transaction.tags.filter(t => t !== tagUUID);
	return Object.assign({}, transaction, { tags: updatedTags});
}

export default unTagTransaction;